import { render } from "./BaseFormButton.vue?vue&type=template&id=4b0f7e72"
import script from "./BaseFormButton.vue?vue&type=script&lang=js"
export * from "./BaseFormButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseFormButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b0f7e72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b0f7e72', __exports__)) {
    console.log('reload')
    api.reload('4b0f7e72', __exports__)
  }
  
  module.hot.accept("./BaseFormButton.vue?vue&type=template&id=4b0f7e72", () => {
    console.log('re-render')
    api.rerender('4b0f7e72', render)
  })

}


export default __exports__